import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import { useTranslation } from 'react-i18next';
import TerminalOrderDialog from '../settings/TerminalOrderDialog';
import { GuideLayout, GuideWay } from './GuideStepPanel';
import { STEP_GUIDES } from './stepGuides';

/**
 * Terminal step: guide + the terminal order form (same dialog as Settings, Integraatiot),
 * which mails Verstaani support. Flips to a confirmation once requested.
 */
function TerminalStepPanel({ requestedAt, onRequested }) {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [requested, setRequested] = useState(Boolean(requestedAt));

  const guide = STEP_GUIDES.terminal;

  const handleSent = (payload) => {
    setDialogOpen(false);
    setRequested(true);
    if (onRequested) onRequested(payload);
  };

  return (
    <GuideLayout shot={guide.shot} shotAlt={t('onboardingChecklist.steps.terminal.title')}>
      <Typography sx={{ fontSize: '13.5px', lineHeight: 1.6 }}>
        {t('onboardingChecklist.steps.terminal.guide.intro')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {guide.ways.map((way, index) => (
          <GuideWay
            key={index}
            icon={way.icon}
            title={t(`onboardingChecklist.steps.terminal.guide.ways.${index}.title`)}
            description={t(`onboardingChecklist.steps.terminal.guide.ways.${index}.desc`)}
          />
        ))}
      </Box>

      {requested ? (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <CheckCircleIcon sx={{ fontSize: 18, color: 'success.main', mt: '2px', flexShrink: 0 }} />
          <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
            {t('onboardingChecklist.steps.terminal.requestedHint')}
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pt: 0.5, flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            color="secondary"
            startIcon={<PointOfSaleIcon />}
            onClick={() => setDialogOpen(true)}
            sx={{ textTransform: 'none' }}
            data-testid="onboarding-terminal-request"
          >
            {t('onboardingChecklist.steps.terminal.guide.cta')}
          </Button>
          <Typography sx={{ fontSize: '12px', color: 'text.disabled', fontWeight: 600 }}>
            {t('onboardingChecklist.steps.terminal.guide.ctaWhere')}
          </Typography>
        </Box>
      )}
      <TerminalOrderDialog open={dialogOpen} onClose={() => setDialogOpen(false)} onSent={handleSent} />
    </GuideLayout>
  );
}

export default TerminalStepPanel;
